const strings = {
  NO_LIMIT: 'Ingen gräns',
  MAX_ONE_BOOKING: '1 bokning åt gången',
  BOOKINGS_AT_A_TIME: 'bokningar åt gången',
  ONE_WEEK: '1 vecka',
  WEEKS: 'veckor'
}

export default strings




// WEBPACK FOOTER //
// ./src/helpers/Functions/strings.js